{
  "id": "campaign-089",
  "name": "Shaggy Gate",
  "seed": "campaign:89",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,L__L...,",
    ",,h,,__..h.,",
    ",,,,,__....,",
    ",i,i,__.i.i.",
    ",,,,,__.....",
    ",,,,T__T....",
    ",i,i,__.i.i.",
    ",,,*,__,*.,,",
    ",,,,,__,,,,,",
    ",i,i,__,i,i,",
    ",,,,,__,,,,,",
    ",,,,,__,,,,,",
    ",i,i,__,i,i,",
    ",,,,,__#,,,,",
    ",,,%,__,,,,,",
    "..,,,,#,,x,,",
    "S...,,,,,,,,"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 10,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 2
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 5,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 7
    },
    {
      "kind": "gas",
      "x": 4,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 11
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 89,
  "biome": "cemetery",
  "par": {
    "reel": 16044,
    "push": 10288,
    "selfPropelled": 9180,
    "tractor": 5230,
    "zeroTurn": 6214,
    "fairway": 3952
  },
  "routeTries": {
    "par": {
      "reel": 2,
      "push": 11,
      "selfPropelled": 15,
      "tractor": 5,
      "zeroTurn": 12,
      "fairway": 8
    }
  }
}
